module.exports = __webpack_public_path__ + "static/media/galdisa_blogImg29.701c508f.jpg";